import { render, staticRenderFns } from "./TaskViewModal.yaml?vue&type=template&id=68ec5767&component"
import script from "./TaskViewModal.yaml?vue&type=script&lang=ts&component"
export * from "./TaskViewModal.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports